import actionTypes from '@/store/action-types';

const reducer = ( state, { type, payload } ) => {
	switch ( type ) {
		case actionTypes.SET_ACTION_ITEMS:
			return { ...state, actionItems: payload };
		case actionTypes.SET_ACTION_CATEGORIES:
			return { ...state, actionCategories: payload };
		case actionTypes.SET_VIDEO_MODAL_OPEN:
			return {
				...state,
				videoModalOpen: payload,
			};
		case actionTypes.SET_VIDEO_MODAL_ITEM:
			return {
				...state,
				videoModalOpen: true,
				currentVideoModalItem: payload.item || null,
			};
		case actionTypes.SET_LEARN_MORE_DIALOG_OPEN:
			return {
				...state,
				learnMoreDialogOpen: payload,
			};
		case actionTypes.SET_LEARN_MORE_DIALOG_ITEM:
			return {
				...state,
				learnMoreDialogOpen: true,
				currentLearnMoreDialogItem: payload.item || null,
			};
		default:
			return state;
	}
};

export default reducer;
